export const GET_USER_DETAILS_QUERY = `
  query GetUserDetails($userId: String!) {
    getUserDetails(userId: $userId) {
      id
      firstName
      lastName
      email
      roleName
      profileImageURL
      coverImageURL
      acceptedTerms
      permissions
    }
  }
`;
